// ViewDomains.jsx
import React, {useEffect, useState} from "react";


const ViewDomains = () => {
const [domains, setDomains] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

const faqData = [
  {
    domanda: "Come posso acquistare un dominio?",
    risposta: "Cerca il dominio desiderato, aggiungilo al carrello e completa il pagamento in pochi clic.",
  },
  {
    domanda: "Cosa succede dopo l'acquisto di un dominio?",
    risposta: "Riceverai una conferma via email e il dominio sarà immediatamente registrato a tuo nome.",
  },
  {
    domanda: "Posso trasferire un dominio acquistato?",
    risposta: "Sì, puoi trasferire il dominio verso un altro registrar in qualsiasi momento dopo 60 giorni.",
  },
  {
    domanda: "I domini hanno costi di rinnovo?",
    risposta: "Sì, i domini vanno rinnovati annualmente. Il costo varia in base all'estensione scelta.",
  },
  {
    domanda: "Posso ottenere una fattura per l'acquisto?",
    risposta: "Certamente, la fattura verrà generata automaticamente e inviata via email dopo il pagamento.",
  },
];


  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    // Fetching domains data (adjust URL to your API endpoint)
    const fetchDomains = async () => {
      try {
        const response = await fetch("http://your-api-endpoint.com/domains");
        const data = await response.json();
        setDomains(data.domains);
      } catch (error) {
        console.error("Error fetching domains:", error);
      }
    };
    fetchDomains();
  }, []);

    return (
        <div>
            {/* Sezione con testo a sinistra e immagine a destra */}
            <section className="bg-white py-12 max-w-[100%]">
                <div className="container-xl mx-auto px-6 max-w-[80%]">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                        {/* Testo a sinistra */}
                        <div className="text-center lg:text-left">
                            <h1 className="text-4xl lg:text-5xl font-extrabold text-[#94c41c] mb-4">
                                The New Way to Buy Domains
                            </h1>
                            <p className="text-lg text-gray-600 mb-4">
                            Qualunque sia il dominio che desideri acquistare o noleggiare, il nostro processo di trasferimento è semplice e sicuro.
                            </p>
                            <p className="text-lg text-gray-600 mb-6">
                            Ecco come funziona:
                            </p>
                            <ul className="list-inside space-y-3">
                                <li className="flex items-center text-lg text-[#94c41c]">
                                    <span className="mr-3">•</span> Cerca nel nostro database
                                </li>
                                <li className="flex items-center text-lg text-[#94c41c]">
                                    <span className="mr-3">•</span> Trova il dominio perfetto per te
                                </li>
                                <li className="flex items-center text-lg text-[#94c41c]">
                                    <span className="mr-3">•</span> Acquista o noleggia un dominio
                                </li>
                                <li className="flex items-center text-lg font-semibold text-[#94c41c]">
                                    <i className="fa fa-check-circle mr-3 text-[#94c41c]"></i> {/* Icona tick verde */}
                                    Fatto! In media, il dominio sarà tuo entro 24 ore!
                                </li>
                            </ul>
                            <div className="mt-6">

                                {/* Form di ricerca */}
                                <div className="search-form">
                                <form className="w-full max-w-lg mx-auto" action="../search-results" acceptCharset="UTF-8" method="get">
                                    <div className="relative flex rounded-full shadow-lg overflow-hidden">
                                    <input
                                        type="text"
                                        name="terms"
                                        id="terms"
                                        placeholder="Cerca un dominio di impatto qui"
                                        className="w-full px-6 py-3 text-lg text-gray-700 focus:outline-none rounded-l-full"
                                    />
                                    <button
                                        type="submit"
                                        className="bg-[#94c41c] text-white px-6 py-3 hover:bg-[#75b922] transition duration-300 flex items-center justify-center"
                                    >
                                        <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >
                                        <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
                                        <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-center items-center">
                            {/* Immagine */}
                            <div className="col-md flex items-center justify-center text-center w-full md:w-2/3">
                            <a className="block">
                                <img
                                src="/static/undraw_online-transactions.svg"
                                alt="Icona Homepage"
                                className="w-full h-auto object-cover max-w-[400px]"
                                />
                            </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Sezione video */}
            <section className="bg-[#94c41c] min-h-screen text-center py-12">
                <div className="container-xl mx-auto px-6">
                    <div className="flex flex-col items-center">
                        <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6">
                        SeeUrl, il tuo successo inizia dal dominio giusto
                        </h2>

                        <div className="mt-5 w-full max-w-4xl max-w-[80%]">
                            <div className="relative pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                                <iframe
                                    className="absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
                                    src="https://player.vimeo.com/video/574669346"
                                    allow="autoplay; fullscreen"
                                    allowFullScreen
                                    frameBorder="0"
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            {/* Sezione vantaggi */}
            <section className="bg-white py-12">
                <div className="container-xl mx-auto px-6 max-w-[80%]">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 text-center">

                        {/* Primo elemento - Icona Transazioni */}
                        <div className="flex flex-col items-center mb-6">
                            <div className="bg-[#94c41c] w-24 h-24 rounded-full flex items-center justify-center mb-4">
                                {/* Icona Font Awesome per le transazioni */}
                                <i className="fas fa-exchange-alt text-white text-3xl"></i>
                            </div>
                            <h5 className="text-xl font-semibold text-[#94c41c]">
                            +100.000 transazioni concluse con successo
                            </h5>
                        </div>

                        {/* Secondo elemento - Icona Domini Premium */}
                        <div className="flex flex-col items-center mb-6">
                            <div className="bg-[#94c41c] w-24 h-24 rounded-full flex items-center justify-center mb-4">
                                {/* Icona Font Awesome per domini premium */}
                                <i className="fas fa-cogs text-white text-3xl"></i>
                            </div>
                            <h5 className="text-xl font-semibold text-[#94c41c]">
                                +10M Premium Domain Names
                            </h5>
                        </div>

                        {/* Terzo elemento - Icona Rating Trustpilot */}
                        <div className="flex flex-col items-center mb-6">
                            <div className="bg-[#94c41c] w-24 h-24 rounded-full flex items-center justify-center mb-4">
                                {/* Icona Font Awesome per le stelle di Trustpilot */}
                                <i className="fas fa-star text-white text-3xl"></i>
                            </div>
                            <h5 className="text-xl font-semibold text-[#94c41c]">
                                Average rating of 9.1 at Trustpilot
                            </h5>
                        </div>

                    </div>
                </div>
            </section>

            {/* Sezione 3 Step */}
            <section className="bg-white py-12">
                <div className="container-xl mx-auto px-6 max-w-[80%]">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

                        {/* Immagine per desktop */}
                        <div className="hidden md:block">
                            {/* Immagine */}
                            <div className="col-md flex items-center justify-center text-center w-full md:w-2/3">
                            <a className="block">
                                <img
                                src="/static/undraw_stepping-up.svg"
                                alt="Icona Homepage"
                                className="w-full h-auto object-cover max-w-[400px]"
                                />
                            </a>
                            </div>
                        </div>

                        {/* Testo e contenuto */}
                        <div className="my-auto">
                            <h2 className="text-3xl font-bold text-[#94c41c] mb-3 mt-5 md:mt-0">
                                Buyer Protection Program
                            </h2>
                            <p className="text-lg text-gray-700">
                                When you buy a domain name, you’re automatically covered by our Buyer Protection
                                Program. It works like this:
                            </p>

                            <ul className="mt-6 space-y-6">

                                {/* Step 1 */}
                                <li className="flex items-start">
                <span className="bg-[#94c41c] text-white p-3 rounded-full text-xl mr-4">
                  <i className="fas fa-shopping-cart"></i>
                </span>
                                    <div>
                                        <h4 className="text-xl font-semibold text-gray-900">Step 1: Passaggio 1: Acquisti o noleggi il nome a dominio</h4>
                                        <p className="text-gray-700">
Hai acquistato direttamente il dominio oppure il venditore ha accettato la tua offerta? In entrambi i casi, il dominio sta per diventare tuo. Tratteniamo il pagamento in modo sicuro mentre procediamo con i prossimi step.
                                        </p>
                                    </div>
                                </li>

                                {/* Step 2 */}
                                <li className="flex items-start">
                <span className="bg-[#94c41c] text-white p-3 rounded-full text-xl mr-4">
                  <i className="fas fa-exchange-alt"></i>
                </span>
                                    <div>
                                        <h4 className="text-xl font-semibold text-gray-900">Step 2: assaggio 2: Gestiamo il trasferimento dal venditore a te</h4>
                                        <p className="text-gray-700">
                                            Dopo aver confermato il pagamento, contattiamo il venditore per trasferire il dominio ai nostri specialisti. Ti forniremo istruzioni personalizzate e supporto passo-passo per completare con successo il trasferimento.
                                        </p>
                                        <p className="text-gray-700">
                                            Importante: ogni estensione (come .com, .it, ecc.) e ogni registrar può avere regole diverse. Ma non preoccuparti, il nostro team esperto ti guiderà in ogni fase.
                                        </p>
                                    </div>
                                </li>

                                {/* Step 3 */}
                                <li className="flex items-start">
                <span className="bg-[#94c41c] text-white p-3 rounded-full text-xl mr-4">
                  <i className="fas fa-hand-holding-usd"></i>
                </span>
                                    <div>
                                        <h4 className="text-xl font-semibold text-gray-900">Passaggio 3: Dopo il trasferimento, paghiamo il venditore</h4>
                                        <p className="text-gray-700">
                                            Una volta che il dominio è stato trasferito con successo al tuo account, procediamo con il pagamento al venditore. La transazione è ora completata!
                                        </p>
                                        <p className="text-gray-700">
                                            Il servizio è gratuito per gli acquirenti. È il venditore a coprire la nostra commissione per la gestione del trasferimento. E se hai bisogno di assistenza anche dopo l'acquisto, siamo qui per aiutarti — senza costi aggiuntivi.
                                        </p>
                                    </div>
                                </li>

                            </ul>

                            {/* Pulsante */}
                            <div className="mt-6">
                                <a
                                    href="/trust_and_security"
                                    className="inline-flex items-center px-5 py-3 text-lg font-semibold text-white bg-[#94c41c] rounded-lg shadow-md hover:bg-black transition duration-300 ml-20 block"
                                >
                                    Ulteriori informazioni su Fiducia e sicurezza
                                    <i className="fas fa-arrow-right ml-2"></i>
                                </a>
                                </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sezione FAQs */}
        <section className="w-[78%] mx-auto px-1 py-10">
        <h1 className="text-4xl font-bold text-center mb-12 text-[#94c41c]">
            Domande frequenti
        </h1>

        {faqData.map((faq, i) => (
            <div key={i} className="border-b border-gray-300 overflow-hidden mb-8 last:mb-0">
            <button
                onClick={() => toggle(i)}
                className={`w-full flex justify-between items-center px-6 py-3 text-left text-black text-lg font-medium bg-transparent hover:bg-[#94c41c] transition-colors duration-300 focus:outline-none`}
            >
                {faq.domanda}
                <span
                className={`ml-4 text-2xl font-bold transition-colors duration-300 ${
                    activeIndex === i ? "text-[#94c41c]" : "text-gray-600"
                }`}
                aria-hidden="true"
                >
                {activeIndex === i ? "−" : "+"}
                </span>
            </button>

            <div
                style={{
                    maxHeight: activeIndex === i ? "500px" : "0px",
                    transition: "max-height 0.3s ease",
                    textAlign: "left",
                }}
                className="px-6 overflow-hidden"
                >
                <p className="py-3 text-black text-base leading-relaxed">{faq.risposta}</p>
                </div>
            </div>
        ))}
        </section>


            {/* Sezione Richiamo Compra Dominio */}
            <section class="bg-[#94c41c] text-center py-12">
                <div class="container-xl mx-auto px-6 max-w-3xl">
                    <h2 class="text-3xl font-bold text-white">Costruisci il tuo Business Online</h2>
                    <p class="text-lg text-white mt-2">
                        Poni solide fondamenta per il tuo business con un dominio d'impatto.
                    </p>

                    {/* Search Form */}
                    <div className="mt-6 flex justify-center">
                    <form action="../search-results" method="get" className="w-full max-w-lg">
                        <div className="relative flex bg-white rounded-full shadow-lg overflow-hidden">
                        <input
                            type="text"
                            name="terms"
                            id="terms"
                            placeholder="Cerca un dominio di impatto qui"
                            className="w-full px-4 py-3 text-lg text-gray-700 focus:outline-none"
                        />
                        <button
                            type="submit"
                            className="bg-[#6d4017] text-white px-6 py-3 rounded-r-full transition duration-300 flex items-center justify-center"
                        >
                            <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            >
                            <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
                            <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                        </div>
                    </form>
                    </div>
                </div>
            </section>

        </div>
    );
};


export default ViewDomains;
